import { render, staticRenderFns } from "./ProofLinkedFileUpload.vue?vue&type=template&id=ffe8a04a&scoped=true"
import script from "./ProofLinkedFileUpload.vue?vue&type=script&lang=js"
export * from "./ProofLinkedFileUpload.vue?vue&type=script&lang=js"
import style0 from "./ProofLinkedFileUpload.vue?vue&type=style&index=0&id=ffe8a04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe8a04a",
  null
  
)

export default component.exports